
import Vue from 'vue';
export default Vue.extend({
  name: 'SuccessButton',
  props: {
    text: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
});
